// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".read[data-v-ad5c8c6a] {\n  color: #999999;\n  cursor: pointer;\n}\n.read + .read[data-v-ad5c8c6a] {\n  margin-left: 30px;\n}\n.active[data-v-ad5c8c6a] {\n  color: #1258bc;\n}\n.log-body[data-v-ad5c8c6a] {\n  width: calc(100% - 40px);\n  height: 100%;\n  margin: 20px auto 0;\n}\n", ""]);
// Exports
module.exports = exports;
